module.exports = __webpack_public_path__ + "static/media/Stylo-Shoes.30e515c5.jpg";